module.exports = __webpack_public_path__ + "images/411f7fb84d605ec164a054f88c44bd71-level3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/level3.png
// module id = 1026
// module chunks = 0